export const variantClass = {
  default: 'bg-gray-200 text-gray-800 border-gray-250',
  primary: 'bg-purple-500/8 text-purple-500 border-purple-500/8',
  success: 'bg-green-500/4 text-green-500 border-green-500/4',
  error: 'bg-destructive/10 text-destructive border-destructive/10',
  warning: 'bg-orange-500/4 text-orange-500 border-orange-500/4',
};

export type Variant = keyof typeof variantClass;
